import { render, staticRenderFns } from "./mmsi.vue?vue&type=template&id=1cb0ac44&"
import script from "./mmsi.vue?vue&type=script&lang=ts&"
export * from "./mmsi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports